import { Base } from '@/api/base'
import { IntroTextResponse } from '@/api/types'

export class IntroText extends Base {
  getIntroTextInformation() {
    return this.get<IntroTextResponse>('/resource/IntroTekst')
  }
}
